import { toast } from "react-toastify";
import axios from "axios";

export const setConfigType = (quotesBy, bindType) => {
  let configType;
  if (quotesBy === "manual") {
    configType = 1;
    if (bindType == "2") {
      configType = 8;
    }
  } else {
    switch (bindType) {
      case "1":
        configType = 1;
        break;
      case "2":
        configType = 2;
        break;
      case "3":
        configType = 3;
        break;
      case "4":
        configType = 4;
        break;
      case "5":
        configType = 5;
        break;
      case "6":
        configType = 6;
        break;
      case "7":
        configType = 7;
        break;
      case "9":
        configType = 9;
        break;
      case "10":
        configType = 10;
        break;
      default:
        configType = 1;
        break;
    }
  }
  if (quotesBy === "external" && false) {
    configType = 6;
  }
  if (quotesBy === "inhouse" && bindType == "6") {
    configType = 7;
  }
  return configType;
};

export const getDocument = (docKey) => {
  axios
    .get(
      process.env.REACT_APP_BASICSERVICE +
        "/api/transactions/get-document?key=" +
        docKey,
      {
        headers: { "x-auth-token": localStorage.getItem("jwt") },
      }
    )
    .then((res) => {
      const link = document.createElement("a");
      try {
        link.href = res.data.url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (e) {
        toast.error("Something went wrong while getting Pdf");
        console.log(e);
      }
    });
};
